module.exports = __webpack_public_path__ + "media/elevadizo/buqueIzquierdaCargadorDerecha-di-3c7b4731.png";